export default __webpack_public_path__ + "static/media/logo.5b10af92.png";